export default {
      id: "twitter-negative-usage",
      viewBox: "0 0 512 512",
      url: "/assets/svg/" + "sprite.svg#twitter-negative-usage",
      toString: function () {
        return this.url;
      }
    }